const routes = [{
  path: '/log',
  component: () => import('@/views/log'),
  name: 'log',
  meta: {
    title: '日志信息管理'
  }
}, {
  path: '/loginlog',
  component: () => import('@/views/log/index'),
  name: 'loginlog',
  meta: {
    title: '日志信息管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/setting/log.js